import { Location } from '../interfaces/location';

export function format(first: string, middle: string, last: string): string {
	return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function prettyPrintJSON(obj: object) {
	return JSON.stringify(obj, null, 2);
}

export function getPropRecursive(obj: object, props: string[]) {
	let value,
		_props = [...props];
	while (_props.length > 0) {
		value = obj[_props.shift()];
	}
	return value;
}

export function arrayOfObjectsDeepSort(a: object, b: object, props: string[]): number {
	const aValue = getPropRecursive(a, props),
		bValue = getPropRecursive(b, props);
	if (aValue === bValue) {
		return 0;
	}
	return aValue > bValue ? 1 : -1;
}

export function arraysHaveOverlap(a: any[], b: any[]): boolean {
	for (var i = 0; i < a.length; i++) {
		if (b.indexOf(a[i]) > -1) {
			return true;
		}
	}
	return false;
}

/**
 * Returns an object with the fetch request and
 * the abortController to cancel the request.
 */
export function abortableFetch(
	request: string,
	opts: any,
): { abort: Function; ready: Promise<Response> } {
	const controller = new AbortController();
	const signal = controller.signal;
	return {
		abort: () => controller.abort(),
		ready: fetch(request, { ...opts, signal }),
	};
}

export function getGoolgeMapsDirectionsLink(location: Location) {
	let encodedAddress = encodeURIComponent(
		`${location.Address}, ${location.City}, ${location.State} ${location.Zip}`,
	);
	return `https://www.google.com/maps/dir//${encodedAddress}`;
}

/**
 * Haversine formula
 * @see https://simplemaps.com/resources/location-distance
 * @returns distance
 */
export function getDistanceFromLatLng(
	lat1: number,
	lng1: number,
	lat2: number,
	lng2: number,
	miles?: boolean,
) {
	if (typeof miles === 'undefined') {
		miles = false;
	}
	function deg2rad(deg) {
		return deg * (Math.PI / 180);
	}
	function square(x) {
		return Math.pow(x, 2);
	}
	const r = 6371; // radius of the earth in km
	lat1 = deg2rad(lat1);
	lat2 = deg2rad(lat2);
	var lat_dif = lat2 - lat1;
	var lng_dif = deg2rad(lng2 - lng1);
	var a =
		square(Math.sin(lat_dif / 2)) +
		Math.cos(lat1) * Math.cos(lat2) * square(Math.sin(lng_dif / 2));
	var d = 2 * r * Math.asin(Math.sqrt(a));
	if (miles) {
		return d * 0.621371;
	} else {
		return d;
	}
}

/**
 * Storybook Docs Helper
 */
export function addCodeExample(component, templateConfig) {
	console.log(component.args);
	if (!component || !templateConfig) return;
	component.parameters = {
		docs: {
			source: {
				code: templateConfig({
					label: component?.args?.label,
					className: component?.args?.className,
				}),
			},
		},
	};
	return component;
}

/**
 * GUID generator
 */
export function guid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (Math.random() * 16) | 0,
			v = c == 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}
